import React from 'react';
export const SearchContext = React.createContext({
    isEssentialsListsEnabled: false,
    isSchoolLevelGivingEnabled: false,
    isSendLocationSearchToMapEnabled: false,
    essentialsData: {}, // Top-level item includes both counts *and* a VO-list; see EssentialsSearchResultsVO
});

